import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { openCloseModalEliminarBateria, doDeleteBateria } from "./action";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class ModalDelete extends React.PureComponent {
  handleCancel = () => {
    this.props.dispatch(openCloseModalEliminarBateria(false, {}));
  }

  handleEliminar = () => {
    this.props.dispatch(doDeleteBateria(this.props.batery));
  }

  render() {
    return (
      <Popup
        title="Eliminar batería"
        showCloseButton
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEliminar}
        width={500}
        height={200}
        contentComponent={() => (
          <div className="modal-delete-mantenedor">
            {this.props.isLoading && <LoadingOverlay />}
            Esta acción es irreversible.
            <br />
            ¿Estás seguro de eliminar la bateria?
            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
              </div>
              <div>
                <Button text="Eliminar" type="danger" onClick={this.handleEliminar} useSubmitBehavior />
              </div>
            </div>
          </div >
        )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEliminar: state.mantenedorBaterias.isOpenModalEliminar,
  batery: state.mantenedorBaterias.batery,
  isLoading: state.mantenedorBaterias.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalDelete);
